// Tablet cutoff for the shared layout — below it the 68px icon rail is replaced by
// the off-canvas drawer. Keep the query in step with $bp-tablet in _breakpoints.scss.
//
// Ask matchMedia rather than comparing window.innerWidth against the number: the CSS
// viewport can measure a pixel wider than innerWidth (fractional device pixel ratio,
// browser zoom), so at exactly 800px `innerWidth <= 800` is true while
// `@media (max-width: 800px)` is false. The body then drops its left padding while
// the rail is still painted over it, clipping the first 68px of every page.
export const TABLET_MEDIA_QUERY = '(max-width: 800px)'

export const isTabletViewport = () => window.matchMedia(TABLET_MEDIA_QUERY).matches
